import { AppSidebar } from "@/components/app-sidebar";
import { TrialBanner } from "@/components/trial-banner";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { TooltipProvider } from "@/components/ui/tooltip";

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <TooltipProvider>
        <AppSidebar />
        <SidebarInset>
          <TrialBanner />
          <header className="flex h-16 shrink-0 items-center gap-2 px-4">
            <SidebarTrigger />
          </header>
          <main className="flex flex-1 flex-col gap-4 p-4 pt-0">
            {children}
          </main>
        </SidebarInset>
      </TooltipProvider >
    </SidebarProvider>
  )
}
